<template>
  <div 
    id="container"
    class="mobile-hide"
    :class="{'--team-data-loaded': teamDataLoaded}">

    <div
      id="team-data-loader"
      @click="showPanel = true">

      <div class="capitalise" v-show="!teamDataLoaded">
        {{ $t("ui.teamAttributes.noDataLoaded") }}
      </div>
      <div class="capitalise" v-show="teamDataLoaded">
        <div>{{ $t("ui.teamAttributes.loaded") }}:</div>
        <div class="team-name">
          {{ $store.state.teamSuitability.selectedTeam.name }}
        </div>
      </div>

      <div 
        class="team-data-reload-btn">
          >> {{ teamDataLoaded ? $t("ui.teamAttributes.reload") : $t("ui.teamAttributes.load") }}
      </div>
    </div>
  
    <div v-if="showPanel" class="ui-hider" @click="closePanel">
      <div class="file-upload-panel" @click.stop>
        <TeamAttributeLoaderFileUploader 
          v-if="step === 0"
          @update:allTeams="updateAllTeams" />

        <TeamAttributesLoaderTeamSelect 
          v-if="step === 1"
          :possibleTeams="possibleTeams"
          @update:selectedTeam="updateSelectedTeam" />

        <button 
          class="cancel-btn capitalise"
          @click="closePanel">
          {{ $t("ui.cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import TeamAttributeLoaderFileUploader from './TeamAttributeLoaderFileUploader';
import TeamAttributesLoaderTeamSelect from './TeamAttributesLoaderTeamSelect';
import { assessPlayingStyleSuitability } from "@/teamAttributeEvaluation";

export default {
  components: {
    TeamAttributeLoaderFileUploader,
    TeamAttributesLoaderTeamSelect
  },

  data: function() {
    return {
      showPanel: false,
      step: 0,
      allTeams: {},
      selectedTeam: "",
    };
  },

  methods: {
    closePanel() {
      this.step = 0;
      this.showPanel = false;
    },

    updateAllTeams(e) {
      this.allTeams = e;
      this.step++;
    },

    updateSelectedTeam(e) {
      this.selectedTeam = e;
      this.$store.commit("setSelectedTeam", {
        name: e,
        rating: this.allTeams[e],
      });
      const suitability = assessPlayingStyleSuitability(this.allTeams[this.selectedTeam]);
      this.$store.commit("setSuitability", suitability);
      this.closePanel();
    }
  },

  computed: {
    possibleTeams() {
      return Object.keys(this.allTeams);
    },

    teamDataLoaded() {
      return !!this.$store.state.teamSuitability.selectedTeam.name;
    }
  }
}
</script>

<style scoped>
#container {
  background: #22604e;
  font-size: x-small;
  margin-top: 40px;
  border-radius: 4px;
  border: solid 1px transparent;
}

#container:hover {
  background: #306a59;
}

#container.--team-data-loaded {
  background: #321450;
  border: solid 1px #fff;
}

#team-data-loader {
  padding: 16px 12px 12px;
  cursor: pointer;
}

.team-name {
  font-weight: bold;
  font-size: initial;
}

.team-data-reload-btn {
  margin-top: 8px;
  text-transform: uppercase;
}

.ui-hider {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0C503CDE;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.file-upload-panel {
  padding: 24px 60px;
  display: flex;
  flex-direction: column;
  background: #121212;
  border-radius: 12px;
  color: #fff;
  gap: 12px;
}

button {
  margin: 4px;
  padding: 6px 16px;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
}

button:hover {
  filter: brightness(1.2);
}

.cancel-btn {
  align-self: flex-end;
  background: #226CB8;
}

.capitalise {
  text-transform: capitalize;
}

@media only screen and (max-width: 767px) {
  .mobile-hide {
    display: none !important;
  }
}
</style>
